export default function CtaSection() {
  return (
    <section className="py-20 md:py-24 px-6 md:px-12 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          Get The Latest Superbuy Sheet
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-lg mx-auto">
          Access the complete Superbuy Spreadsheet with 14 curated fashion categories. Updated weekly with fresh product links and the latest trends.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 mt-8 px-10 py-4 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <span>Explore Superbuy Sheet</span>
          <span className="w-7 h-7 rounded-full border border-background-50/25 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
            <i className="ri-arrow-right-up-line text-xs"></i>
          </span>
        </a>
      </div>

      {/* Bottom product visual banner */}
      <div className="max-w-5xl mx-auto mt-14">
        <div className="flex items-end justify-center gap-2 md:gap-4">
          <img
            src="https://readdy.ai/api/search-image?query=Chunky%20white%20platform%20sneaker%20with%20sage%20green%20accent%20detail%20isolated%20on%20transparent%20background%2C%20product%20photography%20with%20soft%20studio%20lighting%2C%20clean%20modern%20sneaker%20design%20with%20visible%20sole%20texture%2C%20neutral%20warm%20tones%20with%20subtle%20color%20pop%2C%20editorial%20product%20shot%20with%20crisp%20edges&width=300&height=400&seq=banner-shoes-v2&orientation=portrait"
            alt="Superbuy Spreadsheet shoes"
            title="Superbuy Spreadsheet - Shoes"
            className="w-[18%] h-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Woven%20natural%20raffia%20tote%20bag%20with%20leather%20trim%20handles%20isolated%20on%20transparent%20background%2C%20product%20photography%20with%20soft%20studio%20lighting%2C%20visible%20woven%20texture%20detail%2C%20warm%20earthy%20neutral%20tones%2C%20editorial%20product%20shot%20with%20crisp%20clean%20edges&width=300&height=400&seq=banner-bag-v2&orientation=portrait"
            alt="Superbuy Spreadsheet bags"
            title="Superbuy Spreadsheet - Bags"
            className="w-[16%] h-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Sage%20green%20unstructured%20dad%20cap%20with%20curved%20brim%20isolated%20on%20transparent%20background%2C%20product%20photography%20with%20soft%20studio%20lighting%2C%20visible%20cotton%20twill%20texture%2C%20muted%20earthy%20green%20tone%2C%20editorial%20product%20shot%20with%20clean%20minimalist%20aesthetic&width=300&height=400&seq=banner-cap-v2&orientation=portrait"
            alt="Superbuy Spreadsheet headwear"
            title="Superbuy Spreadsheet - Headwear"
            className="w-[14%] h-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20frosted%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20and%20wooden%20cap%20isolated%20on%20transparent%20background%2C%20product%20photography%20with%20soft%20studio%20lighting%2C%20visible%20glass%20texture%20and%20reflections%2C%20warm%20amber%20and%20sand%20tones%2C%20editorial%20beauty%20product%20shot%20with%20refined%20composition&width=300&height=400&seq=banner-perfume-v2&orientation=portrait"
            alt="Superbuy Spreadsheet perfumes"
            title="Superbuy Spreadsheet - Perfumes"
            className="w-[14%] h-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Rich%20cognac%20leather%20belt%20with%20antique%20brass%20buckle%20coiled%20loosely%20isolated%20on%20transparent%20background%2C%20product%20photography%20with%20soft%20studio%20lighting%2C%20visible%20leather%20grain%20and%20patina%20texture%2C%20warm%20earthy%20brown%20tones%2C%20editorial%20product%20shot%20with%20artisanal%20detail&width=300&height=400&seq=banner-belt-v2&orientation=portrait"
            alt="Superbuy Spreadsheet belts"
            title="Superbuy Spreadsheet - Belts"
            className="w-[14%] h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}